import { render } from "./FooterRights.vue?vue&type=template&id=23797a8e&scoped=true&ts=true"
import script from "./FooterRights.vue?vue&type=script&lang=ts"
export * from "./FooterRights.vue?vue&type=script&lang=ts"

import "./FooterRights.vue?vue&type=style&index=0&id=23797a8e&lang=stylus&scoped=true"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23797a8e"]])

export default __exports__